import React from 'react'
import Select from '../select'
import './index.scss'

const Pagination = ({ 
  currentPage = 1, 
  totalPages = 1,
  total = 0,
  limit = 10,
  onPageChange,
  onLimitChange,
  showPrevNext = true 
}) => {
  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange(page);
    }
  }

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);

    if (endPage - startPage < maxVisible - 1) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li 
          key={i} 
          className={`page-item ${i === currentPage ? 'active' : ''}`}
        >
          <a 
            className="page-link" 
            href="#"
            onClick={(e) => {
              e.preventDefault();
              handlePageClick(i);
            }}
          >
            {i}
          </a>
        </li>
      );
    }

    return pages;
  }

  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value)
    if (onLimitChange) {
      onLimitChange(newLimit)
    }
  }

  return (
    <div className="card pagination-card">
      <div className="body" style={{ padding: '0px' }}> 
        <div className="row">
          <div className="col-12">
            <div className="pagination-wrapper d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                {totalPages > 1 && (
                  <ul className="pagination pagination-primary m-b-0 m-r-20">
                    {showPrevNext && (
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <a 
                          className="page-link" 
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            if (currentPage > 1) handlePageClick(currentPage - 1);
                          }}
                        >
                          <i className="zmdi zmdi-arrow-left"></i>
                        </a>
                      </li>
                    )}
                    {renderPageNumbers()}
                    {showPrevNext && (
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <a 
                          className="page-link" 
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            if (currentPage < totalPages) handlePageClick(currentPage + 1);
                          }}
                        >
                          <i className="zmdi zmdi-arrow-right"></i>
                        </a>
                      </li>
                    )}
                  </ul>
                )}
              </div>
              <div className="d-flex align-items-center">
                <span className="m-r-10" style={{marginRight:10}}>Toplam: <strong>{total}</strong> kayıt</span>
                {/* <span className="m-r-10">Sayfa başına:</span> */}
                <div style={{ display: 'flex', alignItems: 'center',paddingTop:15,height:35,margin:10 }}>
                  <Select
                    className="pagination-select"
                    value={limit.toString()}
                    onChange={handleLimitChange}
                    options={[
                      { value: '10', label: '10' },
                      { value: '25', label: '25' },
                      { value: '50', label: '50' },
                      { value: '100', label: '100' }
                    ]}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Pagination

